import React from "react";
import styled from "styled-components";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  NumberField,
  CreateButton,
  TopToolbar,
  FunctionField,
} from "react-admin";

import { ListPagination } from "../../../utils";

const StyledDatagrid = styled(Datagrid)`
  .RaDatagrid-headerCell {
    text-transform: none;
    color: #4a4a4a;
    font-weight: 500;
    white-space: nowrap;
  }

  .RaDatagrid-headerCell.column-total_items,
  .RaDatagrid-rowCell.column-total_items {
    text-align: center;
    max-width: 160px;
    width: 160px;
  }

  .RaDatagrid-rowCell {
    color: #000;
    text-align: left;
  }

  .RaDatagrid-tableWrapper {
    overflow-x: auto;
  }
`;

const statusColorMap = {
  "ENVIO AGENDADO": {
    borderColor: "#2196F3",
    color: "#2196F3",
    backgroundColor: "transparent",
  },
  ENVIANDO: {
    borderColor: "#43A047",
    color: "#43A047",
    backgroundColor: "transparent",
  },
  ENVIADO: {
    borderColor: "#2E7D32",
    color: "#2E7D32",
    backgroundColor: "transparent",
  },
  "ERRO AO ENVIAR": {
    borderColor: "#C62828",
    color: "#C62828",
    backgroundColor: "transparent",
  },
  "ERRO PROCESSAMENTO": {
    borderColor: "#C62828",
    color: "#C62828",
    backgroundColor: "transparent",
  },
};

const getStatusStyle = (status) =>
  statusColorMap[status] || {
    borderColor: "#9E9E9E",
    color: "#616161",
    backgroundColor: "transparent",
  };

const ListActions = () => (
  <TopToolbar>
    <CreateButton
      label="NOVO ENVIO"
      style={{ color: "#1976D2", borderColor: "#1976D2" }}
    />
  </TopToolbar>
);

const ConsolidatedDeliveredOrdersList = (props) => (
  <List
    {...props}
    sort={{ field: "created_at", order: "DESC" }}
    perPage={25}
    pagination={<ListPagination />}
    actions={<ListActions />}
    empty={false}
    exporter={false}
    bulkActionButtons={<div />}
    title="Lista dos Envios"
  >
    <StyledDatagrid>
      <TextField source="description" label="Descrição" />
      <DateField
        source="created_at"
        label="Data de criação"
        locales="pt-BR"
        options={{ year: "numeric", month: "2-digit", day: "2-digit" }}
        emptyText="-"
      />
      <DateField
        source="sent_at"
        label="Data de envio"
        locales="pt-BR"
        options={{
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }}
        emptyText="-"
      />
      <NumberField source="total_items" label="Total de itens" />
      <FunctionField
        label="Status"
        source="status"
        sortBy="status"
        render={(record) => {
          const normalizedStatus = (record?.status || "").toUpperCase().trim();
          const statusStyle = getStatusStyle(normalizedStatus);

          return (
            <span
              style={{
                display: "inline-block",
                padding: "4px 12px",
                borderRadius: "20px",
                border: `1px solid ${statusStyle.borderColor}`,
                color: statusStyle.color,
                backgroundColor: statusStyle.backgroundColor,
                fontSize: "11px",
                fontWeight: 400,
                whiteSpace: "nowrap",
                width: "max-content",
              }}
            >
              {normalizedStatus || "-"}
            </span>
          );
        }}
      />
    </StyledDatagrid>
  </List>
);

export default ConsolidatedDeliveredOrdersList;
